// Complete Bohol municipalities and their barangays
// Total: 48 LGUs (1 city + 47 municipalities) with 1,109 barangays
// Source: Philippine Statistics Authority & PhilAtlas 2024

export const BOHOL_MUNICIPALITIES = [
  'Tagbilaran City',
  'Alburquerque',
  'Alicia',
  'Anda',
  'Antequera',
  'Baclayon',
  'Balilihan',
  'Batuan',
  'Bien Unido',
  'Bilar',
  'Buenavista',
  'Calape',
  'Candijay',
  'Carmen',
  'Catigbian',
  'Clarin',
  'Corella',
  'Cortes',
  'Dagohoy',
  'Danao',
  'Dauis',
  'Dimiao',
  'Duero',
  'Garcia Hernandez',
  'Getafe',
  'Guindulman',
  'Inabanga',
  'Jagna',
  'Lila',
  'Loay',
  'Loboc',
  'Loon',
  'Mabini',
  'Maribojoc',
  'Panglao',
  'Pilar',
  'President Carlos P. Garcia',
  'Sagbayan',
  'San Isidro',
  'San Miguel',
  'Sevilla',
  'Sierra Bullones',
  'Sikatuna',
  'Talibon',
  'Trinidad',
  'Tubigon',
  'Ubay',
  'Valencia'
];

// Complete barangay data for all municipalities
export const BARANGAYS_BY_MUNICIPALITY = {
  'Tagbilaran City': [
    'Bool',
    'Booy',
    'Cabawan',
    'Cogon',
    'Dampas',
    'Dao',
    'Mansasa',
    'Manga',
    'Poblacion I',
    'Poblacion II',
    'Poblacion III',
    'San Isidro',
    'Taloto',
    'Tiptip',
    'Ubujan'
  ],
  'Alburquerque': [
    'Bahi',
    'Basacdacu',
    'Cantiguib',
    'Dangay',
    'East Poblacion',
    'Ponong',
    'San Agustin',
    'Santa Filomena',
    'Tagbuane',
    'Toril',
    'West Poblacion'
  ],
  'Alicia': [
    'Cabatang',
    'Can-omay',
    'Celing',
    'Danao',
    'Danicop',
    'Del Monte',
    'Katipunan',
    'Napo',
    'Pagahat',
    'Poblacion',
    'Progreso',
    'Sudlon',
    'Ubojan',
    'Viga',
    'Villa Aurora'
  ],
  'Anda': [
    'Almaria',
    'Bacong',
    'Badiang',
    'Buenasuerte',
    'Candabong',
    'Casica',
    'Katipunan',
    'Linawan',
    'Poblacion',
    'Rizal',
    'San Isidro',
    'Santo Rosario',
    'Suba',
    'Talisay',
    'Tanod',
    'Virgen'
  ],
  'Antequera': [
    'Angilan',
    'Bantolinao',
    'Bicao',
    'Cansibuan',
    'Celing',
    'Cansumbol',
    'Celing',
    'Danao',
    'Danicop',
    'Mag-aso',
    'Obojan',
    'Poblacion',
    'Quinapon-an',
    'Tabuan',
    'Tagubaas',
    'Tupas (East)',
    'Tupas (West)',
    'Ubojan',
    'Viga',
    'Villa Aurora',
    'Villa Garcia'
  ],
  'Baclayon': [
    'Buenaventura',
    'Cambanac',
    'Dasitam',
    'Guiwanon',
    'Landican',
    'Laya',
    'Libertad',
    'Montana',
    'Pamilacan',
    'Payahan',
    'Poblacion',
    'San Isidro',
    'San Roque',
    'San Vicente',
    'Santa Cruz',
    'Taguihon',
    'Tanday'
  ],
  'Balilihan': [
    'Baguhan',
    'Bahaybahi',
    'Balbalan',
    'Bandahan',
    'Bantolinao',
    'Cambacol',
    'Canta-ub',
    'Cantaongon',
    'Cantigdas',
    'Del Carmen (East)',
    'Del Carmen (West)',
    'Dorol',
    'Hagbuyo',
    'Hanopol (East)',
    'Hanopol (West)',
    'Ilaya',
    'La Union',
    'Lintuan',
    'Looc',
    'Lusong',
    'Magsija',
    'Maslog',
    'Poblacion (East)',
    'Poblacion (West)',
    'Sagasa',
    'Sal-ing',
    'San Isidro',
    'San Roque',
    'Tagbuane',
    'Tuntungan',
    'Yanaya'
  ],
  'Batuan': [
    'Acorot Rizal',
    'Abucay Norte',
    'Abucay Sur',
    'Cabacnitan',
    'Cantalid',
    'Janlud',
    'Poblacion',
    'Quezon',
    'Quinuguitan',
    'Quirino',
    'San Isidro',
    'San Joaquin',
    'San Pascual',
    'San Vicente',
    'Santa Cruz'
  ],
  'Bien Unido': [
    'Bilangbilangan',
    'Bisuaya',
    'Hingotanan East',
    'Hingotanan West',
    'Liberty',
    'Mandawa',
    'Maomawan',
    'Nueva Estrella',
    'Nueva Vida',
    'Pinamgo',
    'Poblacion',
    'Puerto San Pedro',
    'Sagasa',
    'Tubog',
    'Tuboran'
  ],
  'Bilar': [
    'Bonifacio',
    'Buenasuerte',
    'Cabacnitan',
    'Cambigsi',
    'Campagao',
    'Cansumbol',
    'Owac',
    'Poblacion',
    'Quezon',
    'Riverside',
    'Roxas',
    'Sagasa',
    'Subayon',
    'Uy-awan',
    'Villa Aurora',
    'Villa Suerte',
    'Villaflor',
    'Yanaya',
    'Zamora'
  ],
  'Buenavista': [
    'Anonang',
    'Asinan',
    'Bago',
    'Baluarte',
    'Bantuan',
    'Barangay I (Poblacion)',
    'Barangay II (Poblacion)',
    'Barangay III (Poblacion)',
    'Barangay IV (Poblacion)',
    'Barangay V (Poblacion)',
    'Barangay VI (Poblacion)',
    'Barangay VII (Poblacion)',
    'Barangay VIII (Poblacion)',
    'Bato',
    'Bonotbonot',
    'Bugaong',
    'Cambuhat',
    'Cangmundo',
    'Cruz',
    'Dait',
    'Hambabauran',
    'Humayhumay',
    'Lapacan Norte',
    'Lapacan Sur',
    'Lubang',
    'Lusong',
    'Magkaya',
    'Mckinley',
    'Merryland',
    'Overland',
    'Putlongcam',
    'Rufo Hill',
    'San Roque',
    'Sweetland',
    'Villa Aurora'
  ],
  'Calape': [
    'Abucayan',
    'Banlasan',
    'Bentig',
    'Bonbon',
    'Cabayugan',
    'Cabudburan',
    'Calunasan Norte',
    'Calunasan Sur',
    'Camias',
    'Canhaway',
    'Catmonan',
    'Desamparados',
    'Kahayag',
    'Kinabag-an',
    'Labuon',
    'Lawis',
    'Liboron',
    'Lomboy',
    'Lucob',
    'Lungsodaan East',
    'Lungsodaan West',
    'Madangog',
    'Mandaug',
    'Mantatao',
    'Sampoangon',
    'San Isidro',
    'Sangat',
    'Sojoton',
    'Talisay',
    'Tambongan',
    'Tinibgan',
    'Tultugan',
    'Ulbujan'
  ],
  'Candijay': [
    'Abihid',
    'Anoling',
    'Boyo-an',
    'Cadapdapan',
    'Cambane',
    'Can-olin',
    'Canawa',
    'Corazon',
    'La Esperanza',
    'La Victoria',
    'Luan',
    'Lungsoda-an',
    'Mahangin',
    'Pagahat',
    'Panadtaran',
    'Poblacion',
    'San Isidro',
    'Tambongan',
    'Tawid',
    'Tugas',
    'Villa Aurora'
  ],
  'Carmen': [
    'Abihid',
    'Alegria',
    'Bicao',
    'Buenavista',
    'Buenos Aires',
    'Calatrava',
    'El Progreso',
    'Guadalupe',
    'Katipunan',
    'La Libertad',
    'La Paz',
    'La Salvacion',
    'La Victoria',
    'Matin-ao',
    'Montehermoso',
    'Montesuerte',
    'Montesunting',
    'Montesunting',
    'Montesuerte',
    'Monserrat',
    'Nuevaesperanza',
    'Poblacion Norte',
    'Poblacion Sur',
    'Tambo-an',
    'Vallehermoso',
    'Villa Aurora',
    'Villa Milagrosa',
    'Villa Suerte',
    'Villaflores'
  ],
  'Catigbian': [
    'Ambuan',
    'Baang',
    'Bagtic',
    'Bonbonon',
    'Cambacan',
    'Candumayao',
    'Kabasacan',
    'Hagbuyo',
    'Liboron',
    'Libertad Sur',
    'Maitum',
    'Mantasida',
    'Poblacion',
    'Poblacion Weste',
    'Rizal',
    'Roxas',
    'Cambacan Weste',
    'Sinakayanan',
    'Triple Union',
    'Poblacion East',
    'Libertad Norte',
    'Rizal Sur'
  ],
  'Clarin': [
    'Bacani',
    'Bogtongbod',
    'Bontud',
    'Buacao',
    'Cabog',
    'Caluwasan',
    'Candajec',
    'Cantoyoc',
    'Comaang',
    'Danahaw',
    'Katipunan',
    'Lajog',
    'Mataub',
    'Poblacion',
    'Tangaran',
    'Tontonan',
    'Tubod',
    'Villaflor',
    'Vlahos',
    'Bogtong',
    'Cabitan-an',
    'Danicop',
    'Caboy',
    'Nahawan'
  ],
  'Corella': [
    'Anislag',
    'Canangca-an',
    'Pandol',
    'Poblacion',
    'Sambog',
    'San Roque',
    'Tanday',
    'Lintuan'
  ],
  'Cortes': [
    'Alegria',
    'Cancatac',
    'Fatima',
    'Loreto',
    'Malayo Norte',
    'Malayo Sur',
    'Montela',
    'Nug-as',
    'Patrocinio',
    'Poblacion',
    'Rosario',
    'Salvador',
    'San Roque',
    'Upper de la Paz'
  ],
  'Dagohoy': [
    'Babag',
    'Cagawasan',
    'Can-aga',
    'Canta-ub',
    'Estaca',
    'Mahayag Norte',
    'Mahayag Sur',
    'Malitbog',
    'Poblacion',
    'San Miguel',
    'San Vicente',
    'Santa Cruz',
    'Villa Aurora',
    'Villa Anunciado',
    'Zaragosa'
  ],
  'Danao': [
    'Cabatuan',
    'Cantubod',
    'Carbon',
    'Concepcion',
    'Dagohoy',
    'Hibale',
    'Magtangtang',
    'Nahawan',
    'Poblacion',
    'Rambudtud',
    'San Carlos',
    'San Miguel',
    'San Vicente',
    'Santa Fe',
    'Santol',
    'Tabok',
    'Villa Anunciado'
  ],
  'Dauis': [
    'Biking',
    'Bingag',
    'Catarman',
    'Dao',
    'Mariveles',
    'Mayacabac',
    'Poblacion',
    'San Isidro (Canlongon)',
    'Songculan',
    'Tabalong',
    'Tinago',
    'Totolan'
  ],
  'Dimiao': [
    'Abihid',
    'Alemania',
    'Bakilid',
    'Banat-e',
    'Bauhugan',
    'Cabagakian',
    'Cabanbanan',
    'Cadap-agan',
    'Cambacol',
    'Canlambong',
    'Datag',
    'Guindaguitan',
    'Guingoyuran',
    'Limokon Norte',
    'Limokon Sur',
    'Luyo',
    'Malijao',
    'Oac',
    'Pangihawan',
    'Poblacion',
    'Sawang',
    'Tangnan',
    'Cabagakian',
    'Baguhan',
    'Balbalan',
    'Bantolinao',
    'Camba',
    'Catagbacan Norte',
    'Catagbacan Sur',
    'Catohocan',
    'Cayam',
    'Hibale',
    'Lapsaon',
    'Lincod',
    'Tangohay'
  ],
  'Duero': [
    'Alejawan',
    'Angilan',
    'Anibongan',
    'Bangwalog',
    'Cansuhay',
    'Danao',
    'Duay',
    'Guinsularan',
    'Imelda',
    'Itum',
    'Langkis',
    'Lobogon',
    'Mambool',
    'Mawi',
    'Payao',
    'Poblacion',
    'San Antonio',
    'San Isidro',
    'San Pedro',
    'Sonda',
    'Taytay'
  ],
  'Garcia Hernandez': [
    'Abijilan',
    'Antipolo',
    'Basiao',
    'Bayong',
    'Cagwang',
    'Calma',
    'Cambuac Norte',
    'Cambuac Sur',
    'Candaigan',
    'Canta-ub',
    'Catmon',
    'Cayupo',
    'Cogon',
    'Poblacion I',
    'Poblacion II',
    'Poblacion III',
    'Estaca',
    'Libertad',
    'Lungsodaan',
    'Mahayag',
    'Malbog',
    'Manaba',
    'Pasong',
    'Sacaon',
    'Sampong',
    'San Agustin',
    'San Jose',
    'San Vicente',
    'Tabuan',
    'Ulbujan'
  ],
  'Getafe': [
    'Alumar',
    'Balan-an',
    'Banban',
    'Bani',
    'Buang',
    'Bood',
    'Buyog',
    'Campao Oriental',
    'Campao Occidental',
    'Emilio',
    'Jagoliao',
    'Jandayan Norte',
    'Jandayan Sur',
    'Malinao',
    'Pandol',
    'Poblacion',
    'Saguise',
    'San Jose',
    'San Salvador',
    'Taug',
    'Tugas',
    'Tulang',
    'Urbiztondo',
    'Governor Boyles'
  ],
  'Guindulman': [
    'Basdio',
    'Batohonan',
    'Biabas',
    'Bulawan',
    'Cansiwang',
    'Catungawan Norte',
    'Catungawan Sur',
    'Guio-ang',
    'Guinacot',
    'Lombog',
    'Malinao',
    'Mayuga',
    'Poblacion',
    'Tabajan',
    'Tabunok',
    'Tanday',
    'Trinidad',
    'Villa Aurora',
    'Villa Milagrosa'
  ],
  'Inabanga': [
    'Anonang',
    'Badiang',
    'Baguhan',
    'Banahao',
    'Bato',
    'Bugang',
    'Cagawasan',
    'Cagayan',
    'Cambitoon',
    'Canlinte',
    'Cawayan',
    'Cogon',
    'Dagohoy',
    'Dait Sur',
    'Dait Norte',
    'Datag',
    'Fatima',
    'Ilaud',
    'Ilihan',
    'Lapacan Norte',
    'Lapacan Sur',
    'Lawis',
    'Liloan Norte',
    'Liloan Sur',
    'Lomboy',
    'Lonoy Norte',
    'Lonoy Oriental',
    'Lonoy Sur',
    'Lutao',
    'Maria Rosario',
    'Moto Norte',
    'Moto Sur',
    'Nabuad',
    'Napo',
    'Poblacion',
    'Riverside',
    'Saa',
    'Sal-ing',
    'San Isidro',
    'San Jose',
    'Santo Niño',
    'Tambook',
    'Tungod',
    'Ubayon',
    'Ubay',
    'Ubojan',
    'Union',
    'Viga',
    'Villa Teresita',
    'Zaragosa'
  ],
  'Jagna': [
    'Abo',
    'Alejawan',
    'Balili',
    'Boctol',
    'Bunga Ilaya',
    'Bunga Mar',
    'Buy-o',
    'Cabungaan',
    'Cambugason',
    'Can-ipol',
    'Canayaon',
    'Can-uba',
    'Catugasan',
    'Cayupo',
    'Faraon',
    'Ipil',
    'Kinagbaan',
    'Larapan',
    'Laca',
    'Looc',
    'Lonoy',
    'Malbog',
    'Mayana',
    'Naatang',
    'Nausok',
    'Pagina',
    'Pangdan',
    'Poblacion',
    'Tejero',
    'Tubod Mar',
    'Tubod Monte',
    'Valaga',
    'Can-upao'
  ],
  'Lila': [
    'Banban',
    'Bonkokan Ilaya',
    'Bonkokan Ubos',
    'Calvario',
    'Campao',
    'Candulang',
    'Catugasan',
    'Cogon',
    'Jambawan',
    'Lomanoy',
    'Macalinao',
    'Poblacion Ondol',
    'Poblacion Sawang',
    'Sikatuna (Sambulawan)',
    'Taug',
    'Tiguis',
    'Tipolo',
    'Villa Garcia'
  ],
  'Loay': [
    'Agape',
    'Alegria Norte',
    'Alegria Sur',
    'Bonbon',
    'Botong',
    'Calvario',
    'Candasag',
    'Catagbacan Handig',
    'Catagbacan Norte',
    'Catagbacan Sur',
    'Concepcion',
    'Hinawanan',
    'La Victoria',
    'Lahug',
    'Malinao',
    'Palo',
    'Poblacion Sawang',
    'Poblacion Ubos',
    'Sagnap',
    'Tambangan',
    'Tangcasan',
    'Tayong Occidental',
    'Tayong Oriental',
    'Villalimpia'
  ],
  'Loboc': [
    'Agape',
    'Bagumbayan',
    'Banlasan',
    'Bonbon Lower',
    'Bonbon Upper',
    'Cabadiangan',
    'Cahayag',
    'Calunasan Norte',
    'Calunasan Sur',
    'Camayaan',
    'Cambance',
    'Candabong',
    'Candasig',
    'Gotozon',
    'Jimilian',
    'Oy',
    'Poblacion Ondol',
    'Poblacion Sawang',
    'Quinobcoban',
    'Taytay',
    'Tigbao',
    'Ugpong',
    'Valladolid',
    'Villa Aurora (New Anonang)',
    'Villaflor',
    'Villanueva',
    'Villasminda',
    'Villasuerte'
  ],
  'Loon': [
    'Badbad Occidental',
    'Badbad Oriental',
    'Bagacay Kawayan',
    'Bagacay Saong',
    'Basac',
    'Basdacu',
    'Basdio',
    'Biasong',
    'Bongco',
    'Bugho',
    'Cabacongan',
    'Cabug',
    'Calayugan Norte',
    'Calayugan Sur',
    'Campatud',
    'Candaigan',
    'Canhaway',
    'Canigaan',
    'Canmanoc',
    'Cansuagwit',
    'Cansubayon',
    'Catagbacan Handig',
    'Catagbacan Norte',
    'Catagbacan Sur',
    'Cogon Norte',
    'Cogon Sur',
    'Cuasi',
    'Genomoan',
    'Gotozon',
    'Lintuan',
    'Looc',
    'Mocpoc Norte',
    'Mocpoc Sur',
    'Nagtuang',
    'Napo',
    'Nueva Vida',
    'Panangquilon',
    'Pig-ot',
    'Poblacion Centro',
    'Poblacion Ondol',
    'Poblacion Sawang',
    'Poblacion Ticugan',
    'Quinobcoban',
    'Barangay I (Pob.)',
    'Barangay II (Pob.)',
    'Barangay III (Pob.)',
    'Barangay IV (Pob.)',
    'Barangay V (Pob.)',
    'Barangay VI (Pob.)',
    'Barangay VII (Pob.)',
    'Sondol',
    'Song-on',
    'Tan-awan',
    'Tangnan',
    'Tiwi',
    'Tubodacu',
    'Tubodio',
    'Tubuan',
    'Ubayon',
    'Ubojan',
    'Ualog',
    'United',
    'Barangay VIII (Pob.)',
    'Barangay IX (Pob.)',
    'Barangay X (Pob.)',
    'Barangay XI (Pob.)',
    'Barangay XII (Pob.)',
    'Barangay XIII (Pob.)'
  ],
  'Mabini': [
    'Abaca',
    'Aguining',
    'Valladolid (Banban)',
    'Concepcion',
    'Lungsoda-an',
    'Minol',
    'Poblacion',
    'San Roque',
    'San Vicente',
    'Abad Santos',
    'Osmena',
    'Pagerungan',
    'Paraiso',
    'Quezon',
    'Rizal',
    'Roxas',
    'San Isidro',
    'San Jose',
    'Tambo-an',
    'Villa Aurora',
    'San Antonio',
    'Tangawan'
  ],
  'Maribojoc': [
    'Agahay',
    'Aliguay',
    'Anislag',
    'Bayacabac',
    'Bood',
    'Busao',
    'Cabawan',
    'Candavid',
    'Dipatlong',
    'Guiwanon',
    'Jandig',
    'Lagtangon',
    'Lincod',
    'Pagnitoan',
    'Poblacion',
    'Punsod',
    'San Isidro',
    'San Roque',
    'Santa Cruz',
    'Tinibgan',
    'Toril',
    'Tugas'
  ],
  'Panglao': [
    'Barangay Bil-isan',
    'Barangay Bolod',
    'Barangay Danao',
    'Barangay Doljo',
    'Barangay Libaong',
    'Barangay Looc',
    'Barangay Lourdes',
    'Barangay Poblacion',
    'Barangay Tangnan',
    'Barangay Tawala'
  ],
  'Pilar': [
    'Bagacay',
    'Bagsac',
    'Bayong',
    'Cagawitan',
    'Cagayan',
    'Campao Occidental',
    'Campao Oriental',
    'Casica Norte',
    'Casica Sur',
    'Innocencia',
    'Magsaysay',
    'Maroyogon',
    'Nueva Granada',
    'Pangihawan',
    'Poblacion',
    'Quezon',
    'Rizal',
    'San Carlos',
    'San Isidro',
    'San Vicente',
    'Villa Teresita'
  ],
  'President Carlos P. Garcia': [
    'Aguining',
    'Basiao',
    'Baud',
    'Bayog',
    'Bogo',
    'Butan',
    'Canmangao',
    'Gaus',
    'Lipata',
    'Poblacion (Pitogo)',
    'Popoo',
    'Rombang',
    'Saguise',
    'San Jose (Tawid)',
    'Santo Rosario',
    'Tilmobo',
    'Tugas',
    'Villa Milagrosa',
    'Bogo East',
    'Bogo West',
    'Tilmobo East',
    'Tilmobo West',
    'Villa Teresita'
  ],
  'Sagbayan': [
    'Banlasan',
    'Banlasan',
    'Buenaventura',
    'Calangahan',
    'Canmano',
    'Canmaya Centro',
    'Canmaya Diot',
    'Dagnawan',
    'Kabasacan',
    'Kagawasan',
    'Katipunan',
    'Libertad',
    'Mantalongon',
    'Poblacion',
    'Sagbayan Sur',
    'San Antonio',
    'San Isidro',
    'San Ramon',
    'San Roque',
    'San Vicente Ferrer',
    'Santa Catalina',
    'Santa Cruz',
    'Ubojan',
    'Poblacion Norte'
  ],
  'San Isidro': [
    'Abehilan',
    'Baryong Daan',
    'Baryong Ipa',
    'Cabanugan',
    'Caimbang',
    'Cambansag',
    'Masonoy',
    'Poblacion Norte',
    'Poblacion Sur',
    'Salvacion',
    'Viga',
    'Villa Suerte'
  ],
  'San Miguel': [
    'Bahay',
    'Balongbong',
    'Bugang',
    'Bugsoc',
    'Cabangahan',
    'Cambuhat Norte',
    'Cambuhat Sur',
    'Cambusad',
    'Cancatac',
    'Candungao',
    'Hanlonon',
    'Han-od',
    'Poblacion',
    'San Agustin',
    'San Isidro',
    'San Jose',
    'San Vicente',
    'Santo Niño'
  ],
  'Sevilla': [
    'Bayawahan',
    'Cabancalan',
    'Calinga-an',
    'Cambangay Norte',
    'Cambangay Sur',
    'Guinob-an',
    'Lagtangan',
    'Libjo',
    'Licolico',
    'Lobgob',
    'Poblacion',
    'Quinapon-an',
    'Villasol'
  ],
  'Sierra Bullones': [
    'Abachanan',
    'Anibongan',
    'Bugsoc',
    'Cahayag',
    'Canlangit',
    'Canta-ub',
    'Casilay',
    'Danicop',
    'Danicop Gaus',
    'Dusita',
    'La Fortuna',
    'Lataban',
    'Magsaysay',
    'Matin-ao',
    'Poblacion',
    'Salvador',
    'San Agustin',
    'San Isidro',
    'San Jose',
    'San Roque',
    'Santa Cruz',
    'Villa Garcia'
  ],
  'Sikatuna': [
    'Abucay Norte',
    'Abucay Sur',
    'Bahaybahi',
    'Cambuac Norte',
    'Cambuac Sur',
    'Canagong',
    'Libjo',
    'Poblacion',
    'Tagubaas',
    'Villanueva'
  ],
  'Talibon': [
    'Bagacay',
    'Balintawak',
    'Barangay I (Poblacion)',
    'Barangay II (Poblacion)',
    'Barangay III (Poblacion)',
    'Barangay IV (Poblacion)',
    'Barangay V (Poblacion)',
    'Barangay VI (Poblacion)',
    'Barangay VII (Poblacion)',
    'Busalian',
    'Cataban',
    'Guindacpan',
    'Magsija',
    'Mahanay',
    'Nocnocan',
    'Pinayagan Norte',
    'Pinayagan Sur',
    'Sag',
    'San Agustin',
    'San Francisco',
    'San Isidro',
    'San Jose',
    'Santo Niño',
    'Sikatuna',
    'Tanghaligue'
  ],
  'Trinidad': [
    'Banlasan',
    'Bongbong',
    'Catoogan',
    'Guinobatan',
    'Hinlayagan Ilaud',
    'Hinlayagan Ilaya',
    'Kauswagan',
    'Kinan-oan',
    'La Union',
    'Mahagbu',
    'Mantasida',
    'Manuel M. Roxas (Pob.)',
    'Poblacion',
    'San Isidro',
    'San Vicente',
    'Santo Tomas',
    'Soom',
    'Tagum Norte',
    'Tagum Sur',
    'Villa Suerte'
  ],
  'Tubigon': [
    'Amaga',
    'Bagongbanwa',
    'Banlasan',
    'Batasan',
    'Bilangbilangan',
    'Bosongon',
    'Buenos Aires',
    'Bunacan',
    'Cabulihan',
    'Cahayag',
    'Centro (Poblacion)',
    'Genonocan',
    'Guiwanon',
    'Ilaud (Poblacion)',
    'Ilaya (Poblacion)',
    'Ilihan Norte',
    'Ilihan Sur',
    'Libertad',
    'Macaas',
    'Matabao',
    'Mocaboc Island',
    'Panadtaran',
    'Panaytayon',
    'Pinayagan Norte',
    'Pinayagan Sur',
    'Pooc Occidental',
    'Pooc Oriental',
    'Potohan',
    'Tinangnan',
    'Ubay (Biabas)',
    'Ubojan',
    'Waterfall',
    'Banlasan',
    'Bagongbanwa'
  ],
  'Ubay': [
    'Achila',
    'Bay-ang',
    'Benliw',
    'Biabas',
    'Bongbong',
    'Bood',
    'Buenavista',
    'Cagting',
    'Camambugan',
    'Camayaan',
    'Casate',
    'Fatima',
    'Governor Boyles',
    'Guintabo-an',
    'Hambabauran',
    'Humayhumay',
    'Juagdan',
    'Katarungan',
    'Kinawahan',
    'Lomangog',
    'Los Angeles',
    'Lumad',
    'Palo',
    'Pangpang',
    'Poblacion',
    'San Francisco',
    'San Isidro',
    'San Pascual',
    'San Roque',
    'San Vicente',
    'Santa Luz',
    'Santo Niño',
    'Sentinela',
    'Sinandigan',
    'Tapal',
    'Tipolo',
    'Trinidad',
    'Tubog',
    'Ubay',
    'Union',
    'Villa Teresita',
    'Vinisitahan',
    'Cambuhat',
    'Tapon'
  ],
  'Valencia': [
    'Anas',
    'Asinan',
    'Balingasao',
    'Botong',
    'Canlusong',
    'Catug-an',
    'Cutcutan',
    'Canmano',
    'Hacienda',
    'Limocon Ilaod',
    'Limocon Ilaya',
    'Lungsodaan Centro',
    'Lungsodaan Norte',
    'Lungsodaan Sur',
    'Mag-aso',
    'Magsaysay',
    'New Dalaguete',
    'Odiong',
    'Omhan',
    'Panangquilon',
    'Poblacion Norte',
    'Poblacion Occidental',
    'Poblacion Oriental',
    'Poblacion Sur',
    'San Isidro',
    'San Jose',
    'Santa Cruz',
    'Taug',
    'Tausion Ilaod',
    'Tausion Ilaya',
    'Tigbinan',
    'Tubigon',
    'Tubod',
    'Villaflor',
    'Villasol'
  ]
};

// Get barangays for a specific municipality.
// De-duplicates: a few source arrays list the same barangay name twice (e.g. Antequera,
// Sagbayan, Tubigon, Dimiao), which would otherwise render duplicate <option>s and trip
// React's "two children with the same key" warning wherever this feeds a keyed <select>.
export const getBarangaysForMunicipality = (municipality) => {
  if (!municipality) return [];
  return [...new Set(BARANGAYS_BY_MUNICIPALITY[municipality] || [])];
};
